<template lang="html">

  <section class="actualidad wrapper">

    <section class="intro -categoria column-center" :cat="$route.params.id" :min="min">

      <h1 ref="title">{{categorias[$route.params.id]}}</h1>

    </section>


    <template v-if="noticias($route.params.id)">

      <div class="contenedor-noticias row-start container aifs" v-if="noticias($route.params.id).length > 0">
        <noticia v-for="(noticia, key) in noticias($route.params.id)" :key="key" :data="noticia"></noticia>
      </div>

      <div class="error" v-if="showerror && noticias($route.params.id).length == 0">
        <h2>Lo sentimos no hay noticias con esta categoría</h2>
      </div>

    </template>


  </section>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex'

  import noticia from '@/components/parts/noticia-el'

  export default {
    name: 'actualidad',
    mounted() {
      this.$router.push("/");
      // this.checkCategory();
      // $(window).scroll(e => {
      //   let top = $(window).scrollTop();
      //   this.min = (top > $(window).height() / 2 - 70);
      // });
    },
    data() {
      return {
        showerror: false,
        min : false
      }
    },
    computed: {
      ...mapGetters({
        categorias: 'getCategorias',
        noticias: 'getNoticiasByCategory'
      })
    },
    components: {
      'noticia': noticia
    },
    methods: {
      ...mapActions(['requestByCategory']),
      checkCategory() {
        if (this.noticias(this.$route.params.id).length == 0) {
          this.requestByCategory(this.$route.params.id).then(e => {
            this.showerror = (!e) ? true : false;
          }).catch(error => console.log(e));
        }
      }
    },
    watch: {
      '$route'() {
        this.checkCategory();
      }
    },
  }
</script>

<style scoped lang="scss">
  .intro{
    overflow: hidden;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/categoria.vue